module.exports = __webpack_public_path__ + "static/media/electroscopeBall.bee83381.png";